export default "__VITE_ASSET__BcOCN8r2__"